const CARD_VARIANTS = {
  STANDARD: 'standard',
  PLAIN: 'plain',
  PREMIUM: 'premium'
};
const CARD_DENSITIES = {
  DEFAULT: 'default',
  COMFORTABLE: 'comfortable',
  COMPACT: 'compact',
  COLLAPSE: 'collapse'
};

export { CARD_DENSITIES, CARD_VARIANTS };
